<template>
  <div class="content">
    <div class="pay-result">
      <img src="./successOrFail_img/success.png" alt="" />
      <p>支付成功</p>
      <a class="btn" href="http://happytalk.tw/mycard/newPay/pay/#/"
        >繼續充值</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'success',
}
</script>

<style lang="stylus" scoped>
.content {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  text-align: center;
  justify-content: center;
  align-content: center;

  .pay-result {
    position: absolute;
    top: 30%;
  }

  .btn {
    display: inline-block;
    margin-top: 20px;
    border-radius: 5px;
    padding: 6px 24px;
    background: #57c22d;
    color: #fff;
  }
}
</style>
